import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connectModal } from 'redux-modal';
import Button from 'react-bootstrap-button-loader';


class WelcomePopup extends Component {
  render() {
    const { show, user, handleHide, redirectToWizard } = this.props;

    return (
      <Modal show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>Welcome to JobAdX!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Welcome {user.name}!</h3>
          <br />
          <h3>Thank you for signing up to try JobAdX, we're excited to work with you.</h3>
          <br />
          <p>To get started we recommend the steps below:</p>
          <ul className='welcome-list'>
            <li>Use our Campaign Wizard for a step-by-step tour of how to get your job postings on our platform</li> 
            <li>Install the JobAdX pixel on your website to receive all the reporting information through our daily reports</li>
            <li>Add a credit card by going to Account Settings -> Payment Options to get your campaigns started</li>
          </ul>
          <p>
            If at any point you're stuck and need help,
            please drop us an email at <b>support@jobadx.com</b> and our support
            team will get in touch with you.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleHide}>Close</Button>
          <Button
            bsStyle='primary'
            onClick={redirectToWizard}
          >
            Go To Campaign Wizard
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const WelcomePopModal = connectModal({
  name: 'WelcomePopModal'
});

export default WelcomePopModal(WelcomePopup);
